module.exports = __webpack_public_path__ + "static/media/3BOX-103-badge.593fd3a4.svg";